import { useMemo, useState } from "react";
import { hotFlash, hotRank } from "@/mocks/home";

export default function HotRank() {
  const [onlyHot, setOnlyHot] = useState(false);
  const [flash, setFlash] = useState(hotFlash);

  const list = useMemo(
    () => (onlyHot ? hotRank.filter((r) => r.hot) : hotRank),
    [onlyHot]
  );

  const refresh = () => {
    setFlash((prev) => {
      const arr = [...prev];
      const last = arr.pop();
      if (last) arr.unshift(last);
      return arr;
    });
  };

  const maxHeat = hotRank[0].heat;

  return (
    <section id="hot" className="scroll-mt-24 bg-[#201a14] text-[#f4e9dc]">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-end justify-between mb-6 flex-wrap gap-3">
          <div>
            <div className="flex items-center gap-2 text-orange-400 text-xs font-semibold tracking-widest mb-2">
              <i className="ri-flashlight-fill"></i> LIVE · 舆情热力榜
            </div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-[#fff4e6] flex items-center gap-3">
              实时热榜
              <span className="inline-flex items-center gap-1.5 text-xs font-sans font-normal text-[#c9b49c] bg-[#2b231b] rounded-full px-3 py-1">
                <span className="relative flex w-2 h-2">
                  <span className="animate-hotpulse inline-flex w-2 h-2 rounded-full bg-orange-400"></span>
                </span>
                每 10 分钟更新
              </span>
            </h2>
          </div>
          <button
            onClick={() => setOnlyHot(!onlyHot)}
            className={`inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3.5 py-1.5 border whitespace-nowrap transition-colors cursor-pointer ${
              onlyHot
                ? "bg-orange-500 text-[#201a14] border-orange-500"
                : "border-[#5a4b3b] text-[#d8c8b4] hover:border-orange-400 hover:text-orange-300"
            }`}
          >
            <i className="ri-fire-fill"></i>
            {onlyHot ? "正在看爆款" : "只看爆款"}
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* rank list */}
          <ol className="lg:col-span-2 space-y-2">
            {list.map((r, i) => {
              const num = hotRank.indexOf(r) + 1;
              return (
                <li
                  key={r.title}
                  className="group flex items-center gap-3 md:gap-4 bg-[#2b231b] hover:bg-[#33291f] rounded-lg px-3 md:px-4 py-3 transition-colors cursor-pointer"
                >
                  <span
                    className={`font-number text-2xl w-10 text-center shrink-0 ${
                      num <= 3 ? "text-orange-400" : "text-[#7c6b56]"
                    }`}
                  >
                    {String(num).padStart(2, "0")}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h4 className="text-sm text-[#f7ead9] truncate group-hover:text-white transition-colors">
                        {r.title}
                      </h4>
                      {r.hot && (
                        <span className="shrink-0 text-[9px] bg-orange-500 text-[#201a14] rounded px-1.5 py-0.5 font-semibold">
                          HOT
                        </span>
                      )}
                    </div>
                    <div className="mt-1.5 h-1 rounded-full bg-[#4a3a2c] overflow-hidden">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-orange-600 to-amber-400"
                        style={{ width: `${(r.heat / maxHeat) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                  <div className="shrink-0 text-right">
                    <div className="font-number text-xl leading-none text-amber-400">
                      {r.heat.toFixed(1)}
                    </div>
                    <div className="text-[10px] text-[#9c8a74] mt-1">{r.tag}</div>
                  </div>
                </li>
              );
            })}
          </ol>

          {/* flash column */}
          <aside className="rounded-xl bg-[#2b231b] border border-[#4a3a2c] p-4 flex flex-col">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2 text-[#f7ead9] font-semibold text-sm">
                <i className="ri-radio-2-line text-orange-400 text-lg"></i>
                快讯速递
              </div>
              <button
                onClick={refresh}
                className="inline-flex items-center gap-1 text-[11px] text-[#c9b49c] hover:text-orange-300 transition-colors cursor-pointer"
              >
                <i className="ri-refresh-line text-sm"></i>刷新
              </button>
            </div>
            <ul className="flex-1 space-y-1 overflow-hidden">
              {flash.map((f, i) => (
                <li
                  key={i}
                  className="flex gap-2.5 text-[13px] leading-6 text-[#e3d3c0] py-2 border-b border-[#3a3024] last:border-0"
                >
                  <i className="ri-record-circle-line text-orange-500 mt-1.5 shrink-0"></i>
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            <p className="mt-3 text-[10px] text-[#9c8a74] border-t border-[#3a3024] pt-2">
              快讯仅呈现事实层面进展，深度还原见下方「事件全记录」
            </p>
          </aside>
        </div>
      </div>
    </section>
  );
}